  document.addEventListener('DOMContentLoaded', function() {
    // Get elements
    const megaMenu = document.getElementById('customMegaMenu');
    const allCategoriesLi = document.querySelector('li.all-categories');
    const col1List = document.getElementById('mega-col-1');
    const col2List = document.getElementById('mega-col-2');
    const col3List = document.getElementById('mega-col-3');

    if (!megaMenu || !allCategoriesLi) {
      console.log('Megamenu elements not found');
      return;
    }

    // Function to update menu position
    function updateMenuPosition() {
      const rect = allCategoriesLi.getBoundingClientRect();
      megaMenu.style.top = (rect.bottom) + 'px';
    }

    // Build category structure (data emitted by snippets/custom-mega-menu.liquid)
    const categories = window.haloMegaMenuCategories || [];

    // Render Column 1 - Categories
    function renderCol1() {
      col1List.innerHTML = '';
      categories.forEach((cat, idx) => {
        const li = document.createElement('li');
        li.className = idx === 0 ? 'active' : '';
        li.innerHTML = `<a href="${cat.url}">${cat.title}</a>`;
        li.addEventListener('mouseenter', () => renderCol2and3(idx, 0));
        col1List.appendChild(li);
      });
    }

    // Render Column 2 - Subcategories
    function renderCol2(catIdx) {
      col2List.innerHTML = '';
      const category = categories[catIdx];
      if (!category || !category.subcategories) return;

      category.subcategories.forEach((subcat, idx) => {
        const li = document.createElement('li');
        li.className = idx === 0 ? 'active' : '';
        li.innerHTML = `<a href="${subcat.url}">${subcat.title}</a>`;
        li.addEventListener('mouseenter', () => renderCol3(catIdx, idx));
        col2List.appendChild(li);
      });
    }

    // Render Column 3 - Items
    function renderCol3(catIdx, subcatIdx) {
      col3List.innerHTML = '';
      const subcat = categories[catIdx]?.subcategories[subcatIdx];
      if (!subcat || !subcat.items.length) {
        col3List.innerHTML = '<li style="color: #999; padding: 10px;">No items</li>';
        return;
      }

      subcat.items.forEach(item => {
        const li = document.createElement('li');
        li.innerHTML = `<a href="${item.url}">${item.title}</a>`;
        col3List.appendChild(li);
      });
    }

    function renderCol2and3(catIdx, subcatIdx) {
      renderCol2(catIdx);
      renderCol3(catIdx, subcatIdx);
      updateActiveStates(catIdx, subcatIdx);
    }

    function updateActiveStates(catIdx, subcatIdx) {
      col1List.querySelectorAll('li').forEach((li, idx) => {
        li.classList.toggle('active', idx === catIdx);
      });
      col2List.querySelectorAll('li').forEach((li, idx) => {
        li.classList.toggle('active', idx === subcatIdx);
      });
    }

    // Show menu on hover
    allCategoriesLi.addEventListener('mouseenter', () => {
      updateMenuPosition();
      megaMenu.classList.add('active');
    });

    // Hide menu on leave
    allCategoriesLi.addEventListener('mouseleave', () => {
      megaMenu.classList.remove('active');
    });

    megaMenu.addEventListener('mouseleave', () => {
      megaMenu.classList.remove('active');
    });

    // Update position on scroll/resize
    window.addEventListener('scroll', updateMenuPosition);
    window.addEventListener('resize', updateMenuPosition);

    // Initialize
    if (categories.length > 0) {
      renderCol1();
      renderCol2and3(0, 0);
      updateMenuPosition();
    }
  });
